<template>
    <div class="flex flex-1 gap-x-8 px-8 mb-4">
        <jet-nav-link
            :href="route('reports.all.index')"
            :active="route().current('reports.all.index')"
            :class="{ 'active': route().current('reports.all.index') }"
            class="text-base subnav"
        >All</jet-nav-link>

        <jet-nav-link
            :href="route('reports.retail.index')"
            :active="route().current('reports.retail.index')"
            :class="{ 'active': route().current('reports.retail.index') }"
            class="text-base subnav"
        >Retail</jet-nav-link>

        <jet-nav-link
            :href="route('reports.wholesale.index')"
            :active="route().current('reports.wholesale.index')"
            :class="{ 'active': route().current('reports.wholesale.index') }"
            class="text-base subnav"
        >Wholesale</jet-nav-link>

        <jet-nav-link
            :href="route('reports.schools.index')"
            :active="route().current('reports.schools.index')"
            :class="{ 'active': route().current('reports.schools.index') }"
            class="text-base subnav"
        >Schools</jet-nav-link>
    </div>
</template>

<script>
import JetNavLink from '@/Jetstream/NavLink';

export default {
    name: 'ReportsNavigation',
    components: {
        JetNavLink,
    },
}
</script>

<style scoped>
.subnav {
    @apply border-white border-b-2 hover:border-red-dark font-semibold;
}
.subnav.active {
    @apply border-b-2 border-red-dark font-bold;
}
</style>
